import { Component } from '@angular/core';
import { BaseModalComponent } from '../../../components/base-modal/base-modal.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { AddIncidentOptions, AddIncidentOptionsDescriptor } from '../models/add-incident-options-model';

@Component({
  standalone: true,
  selector: 'app-add-incident-modal',
  imports: [MatButtonModule, MatIconModule, MatDialogModule, MatRadioModule, FormsModule, BaseModalComponent],
  templateUrl: './add-incident-modal.component.html',
  styleUrl: './add-incident-modal.component.scss',
})
export class AddIncidentModalComponent {
  protected readonly options = Object.values(AddIncidentOptions);
  protected readonly optionsMeta = AddIncidentOptionsDescriptor;
  protected selectedOption: AddIncidentOptions = AddIncidentOptions.Url;

  constructor(private readonly dialogRef: MatDialogRef<AddIncidentModalComponent>) {
    this.dialogRef.disableClose = true;
  }

  protected onContinue(): void {
    this.dialogRef.close(this.selectedOption);
  }

  protected onCancel(): void {
    this.dialogRef.close(false);
  }
}
